import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/login/login-module');

export default function LoginLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/login/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'login',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack screenOptions={{ headerRight: () => null }} />
        </DatastoreProvider>
    );
}
